<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M38.75 32.5H37.5V20C37.5 19.337 37.2366 18.7011 36.7678 18.2322C36.2989 17.7634 35.663 17.5 35 17.5H26.25V7.5C26.25 6.83696 25.9866 6.20107 25.5178 5.73223C25.0489 5.26339 24.413 5 23.75 5H8.75C8.08696 5 7.45107 5.26339 6.98223 5.73223C6.51339 6.20107 6.25 6.83696 6.25 7.5V32.5H5C4.66848 32.5 4.35054 32.6317 4.11612 32.8661C3.8817 33.1005 3.75 33.4185 3.75 33.75C3.75 34.0815 3.8817 34.3995 4.11612 34.6339C4.35054 34.8683 4.66848 35 5 35H38.75C39.0815 35 39.3995 34.8683 39.6339 34.6339C39.8683 34.3995 40 34.0815 40 33.75C40 33.4185 39.8683 33.1005 39.6339 32.8661C39.3995 32.6317 39.0815 32.5 38.75 32.5ZM35 20V32.5H26.25V20H35ZM8.75 7.5H23.75V32.5H21.25V25C21.25 24.6685 21.1183 24.3505 20.8839 24.1161C20.6495 23.8817 20.3315 23.75 20 23.75H12.5C12.1685 23.75 11.8505 23.8817 11.6161 24.1161C11.3817 24.3505 11.25 24.6685 11.25 25V32.5H8.75V7.5ZM18.75 32.5H13.75V26.25H18.75V32.5ZM11.25 15C11.25 14.6685 11.3817 14.3505 11.6161 14.1161C11.8505 13.8817 12.1685 13.75 12.5 13.75H15V11.25C15 10.9185 15.1317 10.6005 15.3661 10.3661C15.6005 10.1317 15.9185 10 16.25 10C16.5815 10 16.8995 10.1317 17.1339 10.3661C17.3683 10.6005 17.5 10.9185 17.5 11.25V13.75H20C20.3315 13.75 20.6495 13.8817 20.8839 14.1161C21.1183 14.3505 21.25 14.6685 21.25 15C21.25 15.3315 21.1183 15.6495 20.8839 15.8839C20.6495 16.1183 20.3315 16.25 20 16.25H17.5V18.75C17.5 19.0815 17.3683 19.3995 17.1339 19.6339C16.8995 19.8683 16.5815 20 16.25 20C15.9185 20 15.6005 19.8683 15.3661 19.6339C15.1317 19.3995 15 19.0815 15 18.75V16.25H12.5C12.1685 16.25 11.8505 16.1183 11.6161 15.8839C11.3817 15.6495 11.25 15.3315 11.25 15Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsHospital'
})

defineProps({
  fill: {
    type: String,
    default: '#361564'
  }
})
</script>
